<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <div class="row">
            <CCol sm="6" class="align-self-center">
              <strong>Institute List</strong>
            </CCol>
          </div>
        </CCardHeader>
        <CCardBody>
          <CAlert
              :color="messageColor"
              closeButton
              :show.sync="dismissCountDownS"
              fade
          >{{ alertMessage }}
          </CAlert
          >
          <CRow>
            <CButton type="submit" size="sm" color="primary" style="margin-left: 20px;" @click="submitData">
              <CIcon name="cil-check-circle" />
              Save Selected Institutes
            </CButton>
          </CRow>
          <br>
          <v-server-table :columns="columns" :url="apiUrl" :options="options" ref="myTable">
            <template #actions="data">
              <CButton
                v-if="data.row.alumniAssociationId != undefined"
                color="warning"
                tooltip="View Member List"
                v-on:click="viewTableRow(data.row.alumniAssociationId)"
              >
                <i class="fas fa-eye"></i>
              </CButton>
            </template>
          </v-server-table>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
import Vue from "vue";
import store from "/src/store/store.js";
import { instituteChain, users, company, country, state, city } from "/src/store/url.js";
import {Mixin} from "/src/mixins/index.js";
import {ServerTable} from "vue-tables-2";
Vue.use(ServerTable, {}, false);

export default {
  name: "instituteChainInstitutes",
  mixins: [Mixin],
  components: {
  },

  data() {
    return {
      messageColor: "success",
      dismissCountDownS: 0,
      alertMessage: "test",
      apiUrl: "",
      selectedInstitutes:[],
      tableData: [], // initial empty data
      columns: ['checkbox', 'name', 'email','actions'], // columns definition
      options: {
        headings: {
          checkbox: '',
          name: 'Name',
          email: 'Email',
        },
        templates: {
          checkbox: (h, row) => {
            return h('input', {
              attrs: {
                name:"itemCheckbox",
                type: 'checkbox',
                value: row.id,
                checked: (row.checked == 1 ? true : false),
              },
              on: {
                change: (event) => this.handleCheckboxChange(event, row),
              },
            });
          },
        },

      },
      editableColumns: ["name", "email"],
      sortable: ["name", "email"],
      filterable: ["name", "email"],
    };
  },
  created(){
    let self = this;
    self.apiUrl = '/institute-chain/list-institute/'+self.$route.params.id;
  },
  mounted() {
    let self = this;
    setTimeout(function(){
      const checkboxes = document.getElementsByName('itemCheckbox');
      checkboxes.forEach(checkbox => {
        if (checkbox.checked) {
          self.selectedInstitutes.push(checkbox.value);
        }
      });


    },1000);
  },
  methods: {
    viewTableRow(item) {
      this.$router.push({path: `/alumni/view/member/${item}`});
    },
    submitData(event) {
      let self = this;
      if(this.selectedInstitutes.length>0) {
        axios.post('institute-chain/assign-institute', {mainInstituteId:this.$route.params.id,collegeIds:this.selectedInstitutes})
          .then(function (response) {
              if (response.status === 200) {
                self.alertMessage = response.data.message;
                self.dismissCountDownS = 10;
                self.messageColor = "success";
              }
          });
      } else {
        alert("Please select data");
      }
    },
    handleCheckboxChange(event, row) {
      if (event.target.checked) {
        this.selectedInstitutes.push(row.id);
      } else {
        let selected = this.selectedInstitutes;
        this.selectedInstitutes = selected.filter(item => item !== row.id);
      }
    },

  },
};
</script>